import '@splidejs/splide/css';
document.addEventListener('DOMContentLoaded', () => {
    // Menu
    const burguerIcon = document.querySelectorAll(".abi-header .abi-header__burguer");
    if (burguerIcon) {
        burguerIcon.forEach(button => {
            button.addEventListener('click', () => {
                const menuContainer = document.querySelector('.abi-header__menu');
                const body = document.querySelector('body');
                menuContainer === null || menuContainer === void 0 ? void 0 : menuContainer.classList.toggle("open");
                body === null || body === void 0 ? void 0 : body.classList.toggle("overflow-y-hidden");
                if (body === null || body === void 0 ? void 0 : body.classList.contains('overflow-y-hidden')) {
                    body.style.overflowY = 'hidden';
                }
                else {
                    body.style.overflowY = 'auto';
                }
            });
        });
    }
    // Timeout to wait the complete modal loading
    setTimeout(() => {
        // Messages modal
        const modalButtons = document.querySelectorAll('[data-toggle="modalAlternator"]');
        modalButtons.forEach((button) => {
            button.addEventListener('click', () => {
                var _a, _b, _c, _d;
                (_a = document.getElementById('modal-id')) === null || _a === void 0 ? void 0 : _a.classList.toggle("hidden");
                (_b = document.getElementById('modal-id' + "-backdrop")) === null || _b === void 0 ? void 0 : _b.classList.toggle("hidden");
                (_c = document.getElementById('modal-id')) === null || _c === void 0 ? void 0 : _c.classList.toggle("flex");
                (_d = document.getElementById('modal-id-backdrop')) === null || _d === void 0 ? void 0 : _d.classList.toggle("flex");
            });
        });
    }, 1000);
    // Timeout to wait the complete popup loading
    setTimeout(() => {
        // Acvtions for popup
        const PopupButtons = document.querySelectorAll('[data-toggle="popup-alternator"]');
        PopupButtons.forEach((button) => {
            button.addEventListener('click', () => {
                var _a, _b;
                const idPopup = button.getAttribute('data-popup');
                (_a = document.getElementById(`${idPopup}`)) === null || _a === void 0 ? void 0 : _a.classList.toggle("hidden");
                (_b = document.getElementById(`${idPopup}`)) === null || _b === void 0 ? void 0 : _b.classList.toggle("flex");
            });
        });
    }, 1000);
});
